import { inputAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys)

const defaultStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    color: 'solid.900',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'solid.100',
    _placeholder: {
      color: 'solid.300',
      opacity: 1,
    },
    _focus: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _hover: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _active: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _invalid: {
      boxShadow:
        '0px 0px 0px 3px #DF1C413D, 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 1px #DF1C41, 0px 1px 2px 0px #96132C52',
      borderColor: '#DF1C41',
    },
  },
})

const homeStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    color: 'solid.900',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'solid.100',
    _focus: {
      border: 'solid.100',
      outline: 'solid.100',
    },
    _hover: {
      border: 'solid.100',
      outline: 'solid.100',
    },
    _active: {
      border: 'solid.100',
      outline: 'solid.100',
    },
  },
})

const filterSearchStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    color: 'solid.900',
    borderRadius: '8px',
    borderWidth: '0px',
    borderColor: 'solid.100',
    _placeholder: {
      color: 'solid.300',
      opacity: 1,
    },
    _focus: {
      boxShadow: 'none',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _hover: {
      boxShadow: 'none',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _active: {
      boxShadow: 'none',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _invalid: {
      boxShadow:
        '0px 0px 0px 3px #DF1C413D, 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 1px #DF1C41, 0px 1px 2px 0px #96132C52',
      borderColor: '#DF1C41',
    },
  },
})

const noBorderStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    color: 'solid.300',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'White',
    _focus: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
      color: 'solid.300',
    },
    _hover: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
      color: 'solid.300',
    },
    _active: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
      color: 'solid.300',
    },
    _invalid: {
      boxShadow:
        '0px 0px 0px 3px #DF1C413D, 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 1px #DF1C41, 0px 1px 2px 0px #96132C52',
      borderColor: '#DF1C41',
    },
  },
})

const editableStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    color: 'solid.900',
    w: 'auto',
    h: '26px',
    py: '6px',
    px: '8px',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'White',
    _focus: {
      borderColor: 'solid.50',
      outline: 'solid.50',
      color: 'solid.900',
    },
    _hover: {
      borderColor: 'solid.50',
      outline: 'solid.50',
      color: 'solid.900',
    },
    _active: {
      borderColor: 'solid.50',
      outline: 'solid.50',
      color: 'solid.900',
    },
    _invalid: {
      boxShadow:
        '0px 0px 0px 3px #DF1C413D, 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 1px #DF1C41, 0px 1px 2px 0px #96132C52',
      borderColor: '#DF1C41',
    },
  },
})

const contentQuestionStyle = definePartsStyle({
  field: {
    textStyle: 'h-md',
    fontSize: '18px',
    color: 'solid.900',
    border: 'none',
    _focus: {
      color: 'solid.900',
    },
    _hover: {
      color: 'solid.900',
    },
    _active: {
      color: 'solid.900',
    },
  },
})

const paragraphInputStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    fontSize: '14px',
    color: 'solid.400',

    ml: '20px',
    _focus: {
      color: 'solid.900',
    },
    _hover: {
      color: 'solid.900',
    },
    _active: {
      color: 'solid.900',
    },
    _invalid: {
      color: 'solid.900',
    },
  },
})

const multipleChoiceStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    fontSize: '14px',
    color: 'solid.400',
  },
})

const contentStyle = definePartsStyle({
  field: {
    textStyle: 'l-s',
    color: 'solid.900',
    borderRadius: '8px',
    borderWidth: '1px',
    borderColor: 'solid.100',
    _focus: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _hover: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _active: {
      boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
      border: 'solid.100',
      outline: 'solid.100',
    },
    _invalid: {
      boxShadow:
        '0px 0px 0px 3px #DF1C413D, 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 1px #DF1C41, 0px 1px 2px 0px #96132C52',
      borderColor: '#DF1C41',
    },
  },
})

const variants = {
  default: defaultStyle,
  home: homeStyle,
  filterSearch: filterSearchStyle,
  noBorder: noBorderStyle,
  editable: editableStyle,
  contentQuestion: contentQuestionStyle,
  paragraphInput: paragraphInputStyle,
  multipleChoice: multipleChoiceStyle,
  content: contentStyle,
}

export const InputProps = defineMultiStyleConfig({ variants, defaultProps: { variant: 'default' } })
